import { selectIsOutside, useAppSelector } from 'data-state';
import { Quote } from 'quotes/Quote';
import React from 'react';
import { Inside } from './inside';

export function Estimation(props) {
  const isOutside = useAppSelector(selectIsOutside);
  return isOutside ? <Quote {...props} /> : <Inside {...props} />;
}
